import React, { FC } from 'react';
import { styled } from 'linaria/react';
export interface FlexProps extends React.HTMLAttributes<HTMLDivElement> {
  justify?: string;
  alignItems?: string;
  alignContent?: string;
  wrap?: string;
  flex?: string;
  self?: string;
  direction?: string;
  fillHeight?: boolean;
  fillWidth?: boolean;
  /**
   * паддинг
   */
  p?: string;
}
const Flex: FC<FlexProps> = ({
  ...rest
}) => <Inner data-testid="flexbox" {...rest} />;
const _exp = /*#__PURE__*/() => ({
  flex = 'unset'
}) => flex;
const _exp2 = /*#__PURE__*/() => ({
  justify = 'unset'
}) => justify;
const _exp3 = /*#__PURE__*/() => ({
  alignContent = 'unset'
}) => alignContent;
const _exp4 = /*#__PURE__*/() => ({
  alignItems = 'unset'
}) => alignItems;
const _exp5 = /*#__PURE__*/() => ({
  wrap = 'unset'
}) => wrap;
const _exp6 = /*#__PURE__*/() => ({
  self = 'unset'
}) => self;
const _exp7 = /*#__PURE__*/() => ({
  fillHeight = false
}) => fillHeight ? '100%' : 'unset';
const _exp8 = /*#__PURE__*/() => ({
  fillWidth = false
}) => fillWidth ? '100%' : 'unset';
const _exp9 = /*#__PURE__*/() => ({
  direction = 'unset'
}) => direction;
const _exp0 = /*#__PURE__*/() => ({
  p
}) => p || '';
const Inner = /*#__PURE__*/styled('div')({
  name: "Inner",
  class: "i1caqhb5",
  propsAsIs: false,
  vars: {
    "i1caqhb5-0": [_exp()],
    "i1caqhb5-1": [_exp2()],
    "i1caqhb5-2": [_exp3()],
    "i1caqhb5-3": [_exp4()],
    "i1caqhb5-4": [_exp5()],
    "i1caqhb5-5": [_exp6()],
    "i1caqhb5-6": [_exp7()],
    "i1caqhb5-7": [_exp8()],
    "i1caqhb5-8": [_exp9()],
    "i1caqhb5-9": [_exp0()]
  }
});
export default Flex;

require("./Flex.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Flex.tsx");